module.exports = new __parcel__URL__("spotlightHubElementThumbmail.7d5d37c8.svg").toString();